import React from "react";
import { Modal } from "antd";
import { path } from "ramda";
import i18n from "../i18n";
import MessageUtil from "./message";
import LngSelection from "../components/button/LanguageSelection";
import LagnaugeSelection from "../components/button/LanguageSelection";

export const findErrorMessage = (resError)=>{
	const message = path(["data", "message"], resError);
	const errors = path(["data", "errors"], resError);
	return MessageUtil.buildMessageError(errors) || message;
};
export default {
	showWarning: ({title, message})=>{
		Modal.warning({
			title:"Warning", 
			content: message
		});
	},
	showSuccess: (message = "Success") => {
		Modal.success({
			title: "Success",
			content: message,
		});
	},
	showCustomError:({title, message})=>{
		Modal.error({
			title: title,
			content: message,
		});
	},
	showErrorInfo:({title, resError})=>{
		const finalMessage = findErrorMessage(resError);
		if(finalMessage){
			Modal.info({
				title: title,
				content: finalMessage,
			});
		}
		return finalMessage;
	},
	showError:(resError, showEvenEmpty = true)=>{
		const finalMessage = findErrorMessage(resError);
		if(finalMessage || showEvenEmpty){
			Modal.error({
				title: resError.problem,
				content: finalMessage,
			});
		}
		return finalMessage;
	},
	showDefaultError: () => {
		Modal.error({
			title: i18n.t("default_error.title"),
			content: i18n.t("default_error.message"),
		});
	},
	showDeleteAttr: ({ attr: { id, name }, onSubmitDeleteAttr }) => {
		Modal.confirm({
			title: `Are you sure delete ${name} attribute?`,
			content: `If you delete ${name} attribute, you will not be able to roll back`,
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			confirmLoading: true,
			onOk: () => { onSubmitDeleteAttr(id); },
			onCancel() {
				// console.log('Cancel');
			},
		});
	},
	showDeleteEmployee: ({ user: { user }, onSubmitDeleteEmployee }) => {
		Modal.confirm({
			title: `Are you sure delete ${user.email}?`,
			content: `If you delete ${user.email}, you will not be able to roll back`,
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			confirmLoading: true,
			onOk: () => onSubmitDeleteEmployee(user.id),
			onCancel() {
				// console.log('Cancel');
			},
		});
	},
	showDeleteMultipleEmployees: ({ selectedRows, onSubmitDeleteMultiple }) => {
		if (selectedRows.length === 0) return;
		const arraySelected = selectedRows.map(value => value.id);
		Modal.confirm({
			title: `Are you sure delete ${arraySelected.length} items?`,
			content: `If you delete ${arraySelected.length} items, you will not be able to roll back`,
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			confirmLoading: true,
			onOk: () => onSubmitDeleteMultiple(arraySelected),
			onCancel() {
				// console.log('Cancel');
			},
		});
	},
	showLanguageSelection: ({
		title, message, 
		defaultLanguage = "en", 
		okText="Yes", cancelText="No", 
		onOk, onCancel
	})=>{
		let selectLang = "en";
		Modal.confirm({
			title,
			content: <div>
				<div>{message}</div>
				<div style={{display:"flex", justifyContent:"center", marginTop:12}}>
					<LagnaugeSelection 
						selectLagnauge={defaultLanguage} 
						onChanged={(lng)=>{selectLang = lng;}} />
				</div>
			</div>,
			okText,
			cancelText,
			okType: "primary",
			onOk:()=>{onOk(selectLang);},
			onCancel,
		});
	}
};


// WEBPACK FOOTER //
// ./src/util/modal.js